export default {"src":"/_next/static/media/client-05.e0057c55.svg","height":18,"width":86,"blurWidth":0,"blurHeight":0};